import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const STORAGE_KEY = 'welcomeOffer';

const WelcomeOfferContext = createContext({
  offer: null,
  setOffer: () => {},
});

export const useWelcomeOffer = () => useContext(WelcomeOfferContext);

function readStoredOffer() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function WelcomeOfferProvider({ children }) {
  const [offer, setOfferState] = useState(readStoredOffer);

  const setOffer = useCallback((nextOffer) => {
    setOfferState(nextOffer);
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(nextOffer));
    } catch {
      // sessionStorage unavailable — offer just won't survive a reload.
    }
  }, []);

  const value = useMemo(() => ({ offer, setOffer }), [offer, setOffer]);

  return (
    <WelcomeOfferContext.Provider value={value}>
      {children}
    </WelcomeOfferContext.Provider>
  );
}
